module.exports = __webpack_public_path__ + "img/pszczola.02977b61.svg";